import api from "../../utils/API";

const listReportingClient = (params) => {
    return api.get(`/gestion/reportingClient/list`, {params});
};

export {listReportingClient};
